<template>
  <div id="login-form-offline" data-component="login-form-offline">

    <KmOfflineLoginWalkThrough @login-online="loginOnline" @register-online="registerOnline" @guide-user-sign-in="guideUserSignIn"/>

    <!-- Solo login -->
    <b-card class="login-box" v-if="!hServiceConnectivity && !registrationRequired" >
      <form name="form" method="POST" :action="backendUrl+'/callback?client_name=FormClient'">
        <!-- error section todo: refactor -->
        <div
          class="alert alert-danger"
          role="alert"
          v-if="err.includes('username')"
        >
          Username is required!
        </div>
        <div
          class="alert alert-danger"
          role="alert"
          v-else-if="err.includes('password')"
        >
          Password is required!
        </div>

        <!-- username input field -->
        <div class="form-group mb-2">
          <label for="username" class="a11y-hide">{{
            $t("login.username.$")
          }}</label>
          <input
            type="text"
            class="form-control"
            name="username"
            id="username"
            ref="username"
            :placeholder="$t('login.username.placeholder')"
            v-model="user.username"
          />
        </div>
        <!-- password input field -->
        <div class="form-group mb-1">
          <label for="password" class="a11y-hide">{{
            $t("login.password.$")
          }}</label>
          <input
            type="password"
            ref="password"
            :placeholder="$t('login.password.placeholder')"
            class="form-control mb-0"
            name="password"
            id="password"
            v-model="user.password"
          />
        </div>
        <!-- forgot password link -->
        <div>
          <b-button
            id="forgot-pwd-btn"
            variant="link"
            class="m-0 p-0 mb-3"
            @click="forgetPassword"
            >{{ $t("login.password.forgot") }}</b-button
          >
        </div>
        <!-- login button -->
        <div class="form-group">
          <button
            id="login-btn"
            class="btn btn-primary btn-block"
            :disabled="loading"
          >
            <span
              class="spinner-border spinner-border-sm"
              v-show="loading"
            ></span>
            {{ $t("login.enter-button") }}
          </button>
        </div>
        <!-- error section -->
        <div class="form-group error">
          <div v-if="message">
            {{ message }}
            <div v-if="message == 'timedOut'">{{ timeOutMessage() }}</div>
          </div>
        </div>
        <template v-if="false">
          <div class="or-separator">
            <span class="or-text">
              OR
            </span>
          </div>
          <div>
            <button
              id="oidc-btn"
              class="btn btn-primary btn-block"
              :disabled="loading"
              @click.prevent="openIdConnect"
            >
              <span
                class="spinner-border spinner-border-sm"
                v-show="loading"
              ></span>
              Open ID Connect
            </button>
          </div>
        </template>
      </form>
    </b-card>
  </div>
</template>

<script>
//---- components ---------
import KmOfflineLoginWalkThrough from "./KmOfflineLoginWalkThrough.vue"
//---- mixins -------------
import KmOfflineStatusMixin from "./KmOfflineStatusMixin.js"
import LoginFormMixin from "./LoginFormMixin.js"
//---- services -----------
import kmOfflineService from '@/app/services/kmoffline.service';
import NotificationService from '@/app/services/notification.js';
//---- other --------------
//---- 3rd-parties --------

export default {
  name: "loginFormOffline",

  components: {KmOfflineLoginWalkThrough},
  mixins: [KmOfflineStatusMixin, LoginFormMixin],

  computed: {
    // a solo url sent to the online advisor for the callback after authentication
    callbackUrl() {
        let url = this.kmOfflineStatus?.callbackUrl;
        if (!url)
            return null;

        // the following replaceAll is for development so we can access on port 8080
        // without error. But it should work even when not in development because the
        // window.location.port should be 9080, so it would not have any effect. 
        return url.replaceAll('9080', window.location.port);
    },

    // isKMOfflineUninitialized() {
    //   return this.kmOfflineStatus?.kmOffline == 'not-initialized';
    // },

    returningUser() {
      return this.kmOfflineStatus?.returningUser;
    },

  },

  methods: {
    async getUrls() {
        let callbackUrl = this.kmOfflineStatus?.callbackUrl;
        let onlineUrl = this.kmOfflineStatus?.onlineUrl
        if (!callbackUrl || !onlineUrl) {
            try {
                const responseData = await this.$store.dispatch("auth/checkLogin");
                callbackUrl = responseData?.callbackUrl;
            }
            catch (e) {
                if (!callbackUrl)
                    callbackUrl = e?.callbackUrl;
                if (!onlineUrl)
                    onlineUrl = e?.onlineUrl;
            }
        }

        if (!callbackUrl)
            throw 'No callback url found!';

        // the following replaceAll is for development only. We need to remove this. 
        callbackUrl = callbackUrl.replaceAll('9080', window.location.port)
        return { callbackUrl, onlineUrl };
    },

    async registerOnline() {
        await this.onlineAuth("soloRegistrationCreatePwd");
    },

    async loginOnline() {
        await this.onlineAuth("soloOnlineLogin");
    },

    async resetOfflinePassword() {
        await this.onlineAuth("soloRegistrationCreatePwd");
    },

    async forgetPassword() {
        NotificationService.showMessageOk("You must be connected to internet in order to reset your KMOffline password.");
    },

    async onlineAuth(action) {
      // make a last check to see if we're connected
      await kmOfflineService.checkConnectivity(true)
      if (!this.hServiceConnectivity)
        return;

      const urls = await this.getUrls();
      const onlineUrl = urls.onlineUrl; // this one should not be encoded
      const callbackUrl = encodeURIComponent(urls.callbackUrl);
      let parameters = "soloCallbackUrl=" + callbackUrl;
      if (this.returningUser)
        parameters += "&returningUser=" + encodeURIComponent(this.returningUser);
      window.location.href = onlineUrl + "/" + action + ".action?" + parameters;
    },

  }, // methods
};
</script>

<style scoped>
#forgot-pwd-btn {
  font-size: .9rem;
}

.login-box {
  text-align: justify;
}
.or-separator {
  line-height: 0;
  text-align: center;
  border-bottom: 1px solid gray;
  margin: 2rem -30px;
}
.or-text {
  background-color: white;
  padding: 1rem;
  text-align: center;
  color: gray;
}
</style>